import { render, staticRenderFns } from "./ShoppingCartItems.vue?vue&type=template&id=abb2a39c"
import script from "./ShoppingCartItems.vue?vue&type=script&lang=js"
export * from "./ShoppingCartItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports